module.exports = __webpack_public_path__ + "static/img/live_type04.3bf0167b.png";